export enum MessageTypeWebSocket {
  AUTH = "auth",
  CHAT = "chat",
  CHAT_ROOM_LIST = "chat_list",
  CHAT_ROOM_ITEM_LIST = "event_list",
  CHAT_ROOM_ITEM = "event",
  BOT_STAGE_CHANGED = "flexo_stage_changed",
  GET_CHAT_EVENTS = "get_events",
  QUESTIONNAIRE_ANSWERED = "questionnaire_answered",
  NEW_QUESTIONNAIRE = "new_questionnaire",
  RESULT = "result",
  STATUS = "status",
  STRIPE_ACCOUNT_STATUS_CHANGED = "stripe_account_status_changed",
  USER_CHANGED = "user_changed",
  USER_STATUS_CHANGE = "user_status_change",
  PING = "ping",
  SHOW_PLANS = "show_plans",
  REASSIGN_REQUEST_COMPLETED = "reassign_request_completed",
  ASSIGNMENTS_USER_ADDED = "assignments_user_added",
  ASSIGNMENTS_USER_ASSIGNED = "assignments_user_assigned",
  VIDEO_CALL_ROOM_CREATED = "video_call_room_created",
  VIDEO_CALL_ROOM_COMPLETED = "video_call_room_completed",
  CONTRACT_SIGNED = "contract_signed",
  NEW_CONTRACT = "new_contract",
  ERROR = "error",
  UCS_CODE = "ucs_code",
}
